
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-video-off" })
export default class IconVideoOff extends Vue {
  sData: string = require("@icon/feather/video-off.svg");
}
